import {Dispatch, FC, SetStateAction, useEffect, useState, useCallback} from 'react'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {schemaOptionByProfile} from '../../../../../../../util/validation'
import {
  assignOptionsByProfile,
  getOption,
  getViwPermissionByOption,
  editNewOptionsByProfile,
} from '../../../../../services'
import {OptionByProfileModel} from '../../../../../model'
import {useCentral} from '../../../../../../../hooks/useCentral'
import {Select} from '../../../../../../../components/UI/Select'
import {ColumnTableWrapper} from '../column'
import {KTableLoading} from '../../../../../../../components/UI'
import {ShowSnackBar} from '../../../../../../../util/functions'
import {SUCCESS_MESSAGE_CREATE, SUCCESS_MESSAGE_UPDATE} from '../../../../../../../util/Constants'
import {ModalComponent} from '../../../../../../../components/Layout/Modal'
import {chunkArray} from '../../../../../../../util/functions'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  getOptionsByProfileList: () => void
  setIdPermissionList: () => void
  idPermission?: ''
  detailpermission?: OptionByProfileModel
}

const ModalAddOptions: FC<Props> = ({
  show,
  setShow,
  setIdPermissionList,
  getOptionsByProfileList,
  idPermission,
  detailpermission,
}) => {
  const {currentTabItem} = useCentral()
  const [option, setOption] = useState<OptionByProfileModel[] | any>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [datpermission, setDataPermission] = useState<any[]>([])
  const [permissionByOption, setPermissionByOption] = useState<OptionByProfileModel[] | any>([])
  const [textMessage, setTextMessage] = useState<string>('')
  const methods = useForm<OptionByProfileModel>({
    resolver: yupResolver(schemaOptionByProfile),
  })

  const {
    control,
    setValue,
    handleSubmit,
    setError,
    reset,
    formState: {errors},
  } = methods

  const getOptionList = async () => {
    try {
      let obj = {
        aplicacionId: currentTabItem?.aditionalInformation?.aplicacionId,
      }
      const response = await getOption(obj, 1, 100)
      let data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
      setOption(mappedSites)
    } catch (error) {}
  }
  useEffect(() => {
    if (idPermission) {
      setValue('vistaPermisoId', detailpermission?.vistaPermisoId)
      getViwPermissionByOptionList(detailpermission?.vistaPermisoId, currentTabItem.idToEdit)
    }
  }, [idPermission])
  const getViwPermissionByOptionList = async (id: any, profile: string = '') => {
    try {
      setLoading(true)
      const response = await getViwPermissionByOption(
        currentTabItem.aditionalInformation?.aplicacionId || '',
        profile,
        1,
        id,
      )
      let data = response.data.data
      setDataPermission(data)
      const chunked = chunkArray(data, 10) ?? []

      setPermissionByOption(chunked)
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    getOptionList()
  }, [])

  const handleClose = () => {
    setShow(false)
    reset()
    setIdPermissionList()
    setDataPermission([])
    setPermissionByOption([])
  }

  const onSubmit = async (data: OptionByProfileModel) => {
    try {
      if (!idPermission) {
        let getTrues = datpermission.filter((item) => item.flagActions)
        if (getTrues.length === 0) {
          setTextMessage('Debes activar un permiso')
          return
        }
      }
      let structureDataCreate = datpermission.map((item) => ({
        Item1: item.id,
        Item2: item.flagActions,
      }))
      let getTrusValuesCreate = structureDataCreate.filter((item) => item.Item2)
      let structureDataUpdate = datpermission.map((item) => {
        let obj: any = {}
        if (item.perfilVistaPermisoOpcionId && item.perfilVistaPermisoOpcionId !== '') {
          obj.Item1 = item.id
        }
        obj.Item2 = item.id
        obj.Item3 = item.flagActions
        return obj
      })
      let getTrusValuesUpdate = structureDataUpdate.filter((item) => item.Item3)
      let isCreating = !idPermission
      let response = isCreating
        ? await assignOptionsByProfile(
            getTrusValuesCreate,
            data.vistaPermisoId || '',
            currentTabItem.idToEdit || '',
          )
        : await editNewOptionsByProfile(
            getTrusValuesUpdate,
            data.vistaPermisoId || '',
            currentTabItem.idToEdit || '',
          )
      let message = isCreating ? SUCCESS_MESSAGE_CREATE : SUCCESS_MESSAGE_UPDATE
      if (!response.data.error) {
        ShowSnackBar(message)
        handleClose()
        getOptionsByProfileList()
      } else {
        ShowSnackBar(response.data.message, 'error')
      }
    } catch (error) {}
  }
  const getDataPermission = useCallback((updatedItem: any) => {
    setTextMessage('')
    setDataPermission((prevData) =>
      prevData.map((item) => (item.id === updatedItem.id ? updatedItem : item)),
    )
  }, [])

  const handleGetPermission = async (val: any) => {
    let value = val ? val : ''
    getViwPermissionByOptionList(value.value)
    setValue('vistaPermisoId', value.value)
    setError('vistaPermisoId', {})
  }

  const isEdit = idPermission ? true : false
  const title = idPermission ? 'Editar Permiso' : 'Agregar Permiso'
  return (
    <ModalComponent
      show={show}
      size='lg'
      title={title}
      handleClose={handleClose}
      handleSubmit={handleSubmit(onSubmit)}
    >
      <FormProvider {...methods}>
        <form>
          <div className='row'>
            <div className='mb-2 col-sm-12 col-md-6'>
              <div className='sdx_form_input'>
                <label className='required form-label'>Módulo</label>
                <input
                  className='form-control sdx-centra-input-form'
                  value={currentTabItem.aditionalInformation?.profile?.applicationName}
                  disabled
                />
              </div>
            </div>
            <div className='mb-2 col-sm-12 col-md-6'>
              <label className='required form-label'>Perfil</label>

              <div className='sdx_form_input'>
                <input
                  className='form-control sdx-centra-input-form'
                  value={currentTabItem.aditionalInformation?.profile?.profileName}
                  disabled
                />
              </div>
            </div>
            <div className='mb-2 col-sm-12 col-md-6'>
              <label className='required form-label'>Opción</label>
              <Select
                control={control}
                name='vistaPermisoId'
                data={option}
                errors={errors}
                disabled={isEdit}
                onChangeValue={handleGetPermission}
              />
            </div>
            <div className='mb-2 col-sm-12 col-md-12'>
              <p style={{color: 'red', fontSize: '12px', fontWeight: 600, marginBottom: 0}}>
                {textMessage}
              </p>
            </div>
            <div
              className='mb-2 col-sm-12 col-md-12 d-flex'
              style={{overflowX: 'auto', position: 'relative', minHeight: '150px'}}
            >
              {loading ? <KTableLoading title='Cargando...' /> : null}

              <>
                {permissionByOption.length > 0 &&
                  permissionByOption?.map((item: any) => {
                    return (
                      <ColumnTableWrapper rowData={item} getDataPermission={getDataPermission} />
                    )
                  })}
              </>
            </div>
          </div>
        </form>
      </FormProvider>
    </ModalComponent>
  )
}

export {ModalAddOptions}
